/*
 * @Description: 投票评选路由
 * @Author: ywl
 * @Date: 2021-03-31 10:03:44
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-01 19:06:11
 */
import { RouteConfig } from "vue-router";
import Layout from "@/layouts/layout.vue";

const votingRoute: RouteConfig[] = [
  {
    path: "/voting",
    component: Layout,
    redirect: "/voting/list.html",
    children: [
      {
        path: "list.html",
        name: "votingList",
        component: () => import("@/views/voting/list.vue"),
        meta: { title: "投票", parentTab: "voting" },
      },

      // {
      //   path: 'creat.html',
      //   name: 'creatVote',
      //   component: () => import('@/views/voting/vote/add/index.vue'),
      //   meta: { title: '新建', parentTab: 'voting' },
      // },
      {
        path: "create.html",
        name: "creatVote",
        component: () => import("@/views/activity_common/create.vue"),
        meta: { title: "投票_新建", parentTab: "voting" },
      },
      {
        path: "templateLibrary.html",
        name: "templateLibraryVote",
        component: () => import("@/views/voting/templateLibrary.vue"),
        meta: { title: "模板库_投票", parentTab: "voting" },
      },
      {
        path: "delete.html",
        name: "deleteVote",
        component: () => import("@/views/voting/delete.vue"),
        meta: { title: "投票_回收站", parentTab: "voting" },
      },

      // {
      //   path: 'add.html',
      //   name: 'addVote',
      //   component: () => import('@/views/voting/vote/add/index.vue'),
      //   meta: { title: '投票_投票', parentTab: 'voting' },
      // },
      {
        path: "result.html",
        name: "resultVote",
        component: () => import("@/views/voting/vote/result/index.vue"),
        meta: { title: "投票_结果", parentTab: "voting" },
      },
      {
        path: "copy.html",
        name: "copyVote",
        component: () => import("@/views/voting/vote/copy/index.vue"),
        meta: { title: "投票_复制", parentTab: "voting" },
      },
    ],
  },

  {
    path: "/voting/add.html",
    name: "addVote",
    component: () => import("@/views/voting/vote/add/index.vue"),
    meta: { title: "投票_投票", parentTab: "voting" },
  },
  {
    path: "/scene.html",
    name: "Scene",
    component: () => import("@/views/voting/vote/scene/index.vue"),
    meta: { title: "" },
  },
];

export { votingRoute };
